import { render, staticRenderFns } from "./AnimalsSection.vue?vue&type=template&id=1cc47c48&scoped=true&"
import script from "./AnimalsSection.vue?vue&type=script&lang=js&"
export * from "./AnimalsSection.vue?vue&type=script&lang=js&"
import style0 from "./AnimalsSection.vue?vue&type=style&index=0&id=1cc47c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc47c48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDatePicker,VIcon,VMenu,VTextField})
